<script setup lang="ts">
import { QDrawerProps } from "quasar";
import PanelHeaderToolbar from "../panel-header-toolbar.vue";

/**
 * Persistent side panel variant.
 *
 * Use the drawer when users should keep the main page visible while working
 * with related content in parallel.
 */
withDefaults(
    defineProps<{
        visible: boolean;
        title: string;
        icon?: string;
        side?: QDrawerProps["side"];
        noSwipeOpen?: boolean;
        testIdPrefix?: string;
    }>(),
    {
        side: "right",
        noSwipeOpen: true,
    }
);
defineEmits<{ (e: "onClose"): void }>();
</script>

<template>
    <q-drawer
        :side="side"
        :model-value="visible"
        overlay
        persistent
        :width="$q.screen.gt.xs ? 400 : $q.screen.width"
        class="overlay overflow-hidden column col-grow no-wrap shadow-1"
        no-swipe-close
        :no-swipe-open="noSwipeOpen"
        :data-qs="testIdPrefix ? `${testIdPrefix}-drawer` : 'title-content-drawer'"
    >
        <PanelHeaderToolbar :title="title" :icon="icon" :test-id-prefix="testIdPrefix" @close="$emit('onClose')" />
        <q-separator />
        <slot />
    </q-drawer>
</template>
